export default "__VITE_ASSET__CHfUz0Rk__"